import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SourceLocationType } from "services/logger.service";
import { TrackerService } from "services/tracker.service";

@Injectable()
export class PartSearchTrackerInterceptor implements HttpInterceptor {
  private readonly searchPartsUrl = "api/parts/SearchParts";

  constructor(private readonly trackerService: TrackerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.method !== "POST" || !req.url.endsWith(this.searchPartsUrl)) {
      return next.handle(req);
    }

    const searchTerm = req.body?.partSearchTerm;

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body?.parts) {
          this.trackerService.trackPartSearch(
            event.body.parts,
            searchTerm,
            SourceLocationType[SourceLocationType.PartSearch],
          );
        }
      }),
    );
  }
}
